export const INSERT_INSTAGRAM_BUTTON = 'insert-instagram-button';
export const INSERT_TWITTER_BUTTON = 'insert-twitter-button';
export const INSERT_PINTEREST_BUTTON = 'insert-pinterest-button';
export const INSERT_FACEBOOK_BUTTON = 'insert-facebook-button';
export const INSERT_TIKTOK_BUTTON = 'insert-tiktok-button';

export const SOCIAL_EMBED_MODAL = 'social-embed-upload-modal';
export const SOCIAL_EMBED_MODAL_INPUT = 'social-embed-upload-modal-input';
export const SOCIAL_EMBED_MODAL_SUBMIT_BTN = 'action-button-save';
export const LINK_PREVIEW_VIEWER = 'link-preview-viewer';

export const PLUGIN_TOOLBAR_REPLACE_TO_LINK_BUTTON = 'plugin-toolbar-replace-to-link-button';
export const PLUGIN_TOOLBAR_LINK_BUTTON = 'plugin-toolbar-link-button';
